import { UserSettingsKeys, useUser } from "@tm/context-distribution"
import { useCallback, useEffect, useState } from "react"
import { useOwnArticlesStore } from "./store"

export function useListSettings() {
    const { userSettings, setUserSetting } = useUser()
    const [isLoading, setIsLoading] = useState(false)

    const { articleListSettings, setArticleListSettings } = useOwnArticlesStore()

    useEffect(() => {
        if (!articleListSettings.initialized) {
            setArticleListSettings({
                initialized: true,
                showPurchasePrice: userSettings?.showPurchasePrice ?? articleListSettings.showPurchasePrice,
            })
        }
    }, [])

    const saveSettings = useCallback(
        async (key: UserSettingsKeys, value: unknown) => {
            setIsLoading(true)
            await setUserSetting(key, value)
            setIsLoading(false)
        },
        [setUserSetting]
    )

    const handleChangeShowPurchasePrice = useCallback(
        (_: unknown, checked: boolean) => {
            setArticleListSettings({
                ...articleListSettings,
                showPurchasePrice: checked,
            })
            saveSettings("SHOW_PURCHASE_PRICE", checked)
        },
        [articleListSettings, saveSettings, setArticleListSettings]
    )

    return {
        isLoading,
        ...articleListSettings,
        handleChangeShowPurchasePrice,
    }
}
